import {handleUnauthorizedResponse} from '../../utils/authSession';
import React, {useCallback, useEffect, useState} from 'react';
import {useAuthStore} from '../../store/useStore';
import {authenticatedApiCall} from '../../utils/api';
import {API_CONFIG} from '../../config/appConfig';
import {Workspace} from '../Operations/styles';
const root = '/api/admin/social-reports';
const reasonLabels = {spam:'스팸', harassment:'괴롭힘·위협', inappropriate_content:'부적절한 콘텐츠', false_information:'잘못된 정보', copyright:'저작권', other:'기타'};

function ReportPhoto({token, reportId, index}) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    let local;
    fetch(`${API_CONFIG.BASE_URL}${root}/${reportId}/media/${index}`, {headers:{Authorization:`Bearer ${token}`}, signal:controller.signal, cache:'no-store'})
      .then(response => {handleUnauthorizedResponse(response, token); if(!response.ok) throw new Error('사진 조회 실패'); return response.blob();})
      .then(blob => {if(!controller.signal.aborted) {local = URL.createObjectURL(blob); setUrl(local);}})
      .catch(() => {});
    return () => {controller.abort(); if(local) URL.revokeObjectURL(local);};
  }, [token, reportId, index]);
  return url ? <img src={url} alt={`신고 증거 사진 ${index+1}`} style={{maxWidth:'100%', maxHeight:260}} /> : <p>사진을 불러오는 중이거나 삭제된 사진입니다.</p>;
}

function ReportItem({item, busy, onDecision, token}) {
  const [notes, setNotes] = useState('');
  const [photos, setPhotos] = useState(false);
  const submit = action => {if(notes.trim()) onDecision(item.id, action, notes.trim());};
  return <article style={{marginBottom:20}}>
    <h3>{item.targetType === 'user' ? '사용자 신고' : item.targetType === 'comment' ? '댓글 신고' : '게시물 신고'}</h3>
    <p>{reasonLabels[item.reason] || item.reason} · {item.createdAt}</p>
    <p style={{whiteSpace:'pre-wrap', overflowWrap:'anywhere'}}>{item.text}</p>
    {item.description && <p>신고 설명: {item.description}</p>}
    {item.imageCount > 0 && <><button onClick={() => setPhotos(!photos)}>{photos ? '사진 닫기' : '신고 사진 확인'}</button>
      {photos && Array.from({length:item.imageCount}, (_, index) => <ReportPhoto key={index} token={token} reportId={item.id} index={index} />)}</>}
    {item.adminNotes && <p>이전 처리: {item.adminNotes}</p>}
    <label>처리 사유<textarea value={notes} maxLength={500} onChange={event => setNotes(event.target.value)} /></label>
    {item.status === 'pending' ? <>
      {item.targetType !== 'user' && <button disabled={busy || !notes.trim()} onClick={() => submit('hide_content')}>콘텐츠 숨김</button>}
      <button disabled={busy || !notes.trim()} onClick={() => submit('restrict_user')}>작성자 소셜 이용 제한</button>
      <button disabled={busy || !notes.trim()} onClick={() => submit('dismiss')}>위반 없음으로 종결</button>
    </> : item.status === 'resolved' && <button disabled={busy || !notes.trim()} onClick={() => submit('restore')}>조치 취소</button>}
  </article>;
}

export function SocialReportsView({items, busy, onDecision, token}) {
  return <>{items.length === 0 && <p>해당 상태의 신고가 없습니다.</p>}{items.map(item => <ReportItem key={item.id} item={item} busy={busy} onDecision={onDecision} token={token} />)}</>;
}

export default function SocialReports() {
  const {token} = useAuthStore();
  const [status, setStatus] = useState('pending');
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const load = useCallback(async after => {
    setBusy(true); setError('');
    try {
      const result = await authenticatedApiCall(`${root}?status=${status}${after ? `&cursor=${encodeURIComponent(after)}` : ''}`, {}, token);
      setItems(previous => after ? [...previous, ...result.data.items] : result.data.items);
      setCursor(result.data.nextCursor);
    } catch (_) {setError('신고 목록을 불러오지 못했습니다.');}
    finally {setBusy(false);}
  }, [token, status]);
  useEffect(() => {load();}, [load]);
  async function decide(id, action, notes) {
    setBusy(true); setError('');
    try {await authenticatedApiCall(`${root}/${id}/decision`, {method:'POST', body:{action, notes}}, token); await load();}
    catch (_) {setError('처리하지 못했습니다. 신고 상태를 새로고침해주세요.');}
    finally {setBusy(false);}
  }
  return <Workspace><h2>커뮤니티 신고 관리</h2>
    <p>신고 내용을 검토한 후 사유를 남기고 조치합니다. 신고만으로 콘텐츠가 자동 삭제되지는 않습니다.</p>
    <label>신고 상태<select value={status} disabled={busy} onChange={event => setStatus(event.target.value)}><option value="pending">검토 대기</option><option value="resolved">조치 완료</option><option value="dismissed">위반 없음</option></select></label>
    <button disabled={busy} onClick={() => load()}>새로고침</button>
    {error && <p role="alert">{error}</p>}
    <SocialReportsView items={items} busy={busy} onDecision={decide} token={token} />
    {cursor && <button disabled={busy} onClick={() => load(cursor)}>이전 신고 더 보기</button>}
  </Workspace>;
}
